import { React, useState, useEffect, useRef } from 'react';
import TOPBAR from "../../components/TopBar";
import SEARCHBAR from "../../components/SeachBar";
import MENUBAR from "../../components/Menu";
import FOOTER from "../../components/Footer";
import { ShimmerButton, ShimmerThumbnail } from "react-shimmer-effects";
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import BREADCRUMBAR from "../../components/BreadCrumBar";
import Modal from 'react-bootstrap/Modal';
import Select from "react-select";
import { Helmet } from 'react-helmet';
import { buildCollectionPageSchema, collectionBreadcrumb } from '../../utils/collectionSchema';


export default function Products() {
    const mainUrl = process.env.REACT_APP_EXPRESS_APP_URL;
    const apiKey = 'crQqKW9uFVL1bSu1uymaWx2UFTcvgdKE';
    const navigate = useNavigate();
    const [isHidden, setIsHidden] = useState(false);
    // const [isLoading, setIsLoading] = useState(true);
    // const [catgoryData, setCatgegoryData] = useState(true);
    const vehicalDetails = JSON.parse(localStorage.getItem('vehical_details'));
    const variantName = vehicalDetails?.variant_name || "";

    const [loader, setLoading] = useState(false);
    const [categoryData, setCategoryData] = useState([]);

    const [dataYear, setDataYear] = useState('');
    const [dataMake, setDataMake] = useState('');
    const [dataModel, setDataModel] = useState('');
    const [dataModelVarient, setDataVarient] = useState('');

    const [selectedYear, setSelectedYear] = useState(vehicalDetails ? vehicalDetails.year : "");
    const [selectedMake, setSelectedMake] = useState(vehicalDetails ? vehicalDetails.make : "");
    const [selectedModel, setSelectedModel] = useState(vehicalDetails ? vehicalDetails.model : "");
    const [selectedVariant, setSelectedVariant] = useState(vehicalDetails ? vehicalDetails.variant : "");

    // const [selectedYear, setSelectedYear] = useState(vehicalDetails ? vehicalDetails.year : "");
    const [selectedMakeName, setSelectedMakeName] = useState(vehicalDetails ? vehicalDetails.make_name : "Make");
    const [selectedModelName, setSelectedModelName] = useState(vehicalDetails ? vehicalDetails.model_name : "Model");
    const [selectedVariantName, setSelectedVariantName] = useState(vehicalDetails ? vehicalDetails.variant_name : "Sub model");

    const [defaultyear, setdefaultyear] = useState(vehicalDetails ? vehicalDetails.year : "");
    const [defaultMakeName, setdefaultMakeName] = useState(vehicalDetails ? vehicalDetails.make_name : "");
    const [defaultModelName, setdefaultModelName] = useState(vehicalDetails ? vehicalDetails.model_name : "");
    const [defaultVariantName, setdefaultVariantName] = useState(vehicalDetails ? vehicalDetails.variant_name : "");
    // const [defaultSearchType, setDefaultSearchType] = useState(vehicalDetails ? vehicalDetails.searchType : "");


    const [isLoading, setIsLoading] = useState(true);
    const [isLoadingMake, setIsLoadingMake] = useState(true);
    const [isLoadingModel, setIsLoadingModel] = useState(true);
    const [isLoadingVarient, setIsLoadingVarient] = useState(true);
    const [inStock, setInStock] = useState(true);




    const [isLoaderMake, setIsLoaderMake] = useState(true);
    const [isLoaderModel, setIsLoaderModel] = useState(true);
    const [isLoaderVarient, setIsLoaderVarient] = useState(true);

    const [isOpenMake, setisOpenMake] = useState(false);
    const [isOpenModel, setisOpenModel] = useState(false);
    const [isOpenVarient, setisOpenVarient] = useState(false);

    const [showMake, setShowMake] = useState(false);
    const [showModel, setShowModel] = useState(false);
    const [showVarient, setShowVarient] = useState(false);


    const [alertshow, setAlertShow] = useState(false);


    const [showModal, setShowModal] = useState(false);
    const [showModalAccount, setShowModalAccount] = useState(false);

    const makeRef = useRef(null);
    const modelRef = useRef(null);
    const variantRef = useRef(null);

    const onClickEdit = () => {
        console.log('i am here+++');
        setShowModal(true)
    }

    const handleClose = () => {
        setSelectedMakeName(vehicalDetails ? vehicalDetails.make_name : "Make")
        setSelectedModelName(selectedModelName)
        setSelectedVariantName(selectedVariantName)

        setShowModal(false)
        setisOpenMake(false);
        setisOpenModel(false);
        setisOpenVarient(false);
        setShowModalAccount(false)


    }

    // const[showOpenModel , setShowOpenModel ] = useState(false);

    const rootCategories = [
        { id: 1, name: 'Interior' },
        { id: 2, name: 'Exterior' },
        { id: 3, name: 'Performance' },
        { id: 4, name: 'Lighting' },
        { id: 5, name: 'Wheels & Tires' },
        { id: 6, name: 'Parts' },
        { id: 7, name: 'Body Parts' },
        { id: 8, name: 'Audio & Electronics' },
        { id: 9, name: 'Automotive Tools' },

    ];
    const [cartItems, setCartItems] = useState("");


    useEffect(() => {
        const storedCartItems = localStorage.getItem('totalCartItems');

        if (storedCartItems) {
            const parsedCartItems = JSON.parse(storedCartItems);
            const numCartItems = Object.values(parsedCartItems);
            const sum = numCartItems.reduce((accumulator, currentValue) => accumulator + currentValue, 0);
            setCartItems(sum);
        }

    }, []);


    useEffect(() => {
        setTimeout(() => {
            setIsHidden(true);
        }, 2000);
    }, []);



    useEffect(() => {
        fetchCategoriesData();
        fetchYearData();
    }, []);

    const fetchCategoriesData = async () => {
        try {
            window.scrollTo({ top: 0, behavior: 'smooth' });
            let config = {
                method: 'get',
                maxBodyLength: Infinity,
                url: `${mainUrl}/api/getAllCategoriesWithorWithoutVehical?year=${selectedYear}&make=${selectedMake}&model=${selectedModel}&variant=${selectedVariant}&variantName=${variantName}`,
            };
            axios.request(config)
                .then((response) => {
                    setCategoryData(response.data);
                    setLoading(true);


                })
                .catch((error) => {
                    console.log(error);
                    setLoading(true);
                    navigate(`/error`);
                });
        } catch (error) {
            console.error('Error fetching data:', error);
            setLoading(true);
            navigate(`/error`);

        }
    }

    const getDriveTypeId = async () => {
        try {
            const variantName = vehicalDetails?.variant_name || "";

            const response = await axios.get(
                `${mainUrl}/api/getDriveTypeId`,
                {
                    params: {
                        year: selectedYear,
                        make: selectedMake,
                        model: selectedModel,
                        variant: selectedVariant,
                        variantName: variantName
                    }
                }
            );

            return response.data?.driveTypeId || "";
        } catch (error) {
            console.log("DriveTypeId error:", error);
            return "";
        }
    };

    // const onSubmit = (id) => {
    const onSubmit = async (id) => {
        const driveTypeId = await getDriveTypeId();

        if (id == 19) {
            if (selectedYear) {
                let config = {
                    method: 'get',
                    maxBodyLength: Infinity,
                    url: `https://api.fitmentatlas.com/v1.1/services/Vehicles/smartsizes/?YearId=${selectedYear}&MakeId=${selectedMake}&ModelId=${selectedModel}&ProductType=wheel&SubmodelID=${selectedVariant}&DriveTypeId=${driveTypeId}`,
                    headers: {
                        'FG-ApiKey': apiKey
                    }
                };

                axios.request(config)
                    .then((response) => {
                        let staggered = false;
                        let fmkWithStaggered = null;
                        // Find the object with isStaggered: true and get its fmk
                        for (const obj of response.data.result) {
                            if (obj.isStaggered === true) {
                                fmkWithStaggered = obj.fmk;
                                staggered = true;
                                break; // Break the loop once we find the first object with isStaggered: true
                            }
                        }

                        // If no object has isStaggered: true, get the fmk from the first object in the array
                        if (fmkWithStaggered === null && response.data.result.length > 0) {
                            fmkWithStaggered = response.data.result[0].fmk;
                        }

                        console.log(fmkWithStaggered); // This will be the fmk value with isStaggered: true or the fmk value from the first object
                        console.log(staggered); // This will be the fmk value with isStaggered: true or the fmk value from the first object

                        if (staggered) {
                            navigate(`/wheels-search-by-vehical/staggered?year=${selectedYear}&make=${selectedMake}&model=${selectedModel}&variant=${selectedVariant}`);
                        } else {
                            navigate(`/wheels-search-by-vehical?year=${selectedYear}&make=${selectedMake}&model=${selectedModel}&variant=${selectedVariant}`);
                        }
                    })
                    .catch((error) => {
                        console.log(error);
                        navigate(`/error`);
                    });



            } else {
                setTimeout(() => {
                    navigate(`/wheels`);
                }, 1000);
            }
        }

        else if (id == 35) {




            const apiKey = 'crQqKW9uFVL1bSu1uymaWx2UFTcvgdKE';
            let staggered = false;
            let fmkWithStaggered = null;

            if (selectedYear) {



                let config = {
                    method: 'get',
                    maxBodyLength: Infinity,
                    url: `https://api.fitmentatlas.com/v1.1/services/Vehicles/smartsizes/?YearId=${selectedYear}&MakeId=${selectedMake}&ModelId=${selectedModel}&ProductType=wheel&SubmodelID=${selectedVariant}&DriveTypeId=${driveTypeId}`,
                    headers: {
                        'FG-ApiKey': apiKey
                    }
                };

                axios.request(config)
                    .then((response) => {
                        const results = response.data;
                        // const fmkWithStaggered = results.result[0].fmk;




                        for (const obj of results.result) {
                            if (obj.isStaggered === true) {
                                fmkWithStaggered = obj.fmk;
                                staggered = true;
                                break; // Break the loop once we find the first object with isStaggered: true
                            }
                        }

                        // If no object has isStaggered: true, get the fmk from the first object in the array
                        if (fmkWithStaggered === null && results.result.length > 0) {
                            fmkWithStaggered = results.result[0].fmk;
                        }


                        let config2 = {
                            method: 'get',
                            maxBodyLength: Infinity,
                            url: `https://api.fitmentatlas.com/v1.1/services/Vehicles/${fmkWithStaggered}`,
                            headers: {
                                'FG-ApiKey': apiKey
                            }
                        };


                        axios.request(config2)
                            .then((response) => {
                                const results2 = response.data;
                                let vehicleType = results2.result.vehicleTypeName;
                                const vehicleChassis = results2.result.vehicleChassis;
                                const liftedOptions = vehicleChassis.vehicleLiftedSizes;


                                if (staggered === true) {
                                    navigate(`/tires/tires-with-vehicle-staggered?year=${selectedYear}&make=${selectedMake}&model=${selectedModel}&variant=${selectedVariant}`);

                                }

                                if (staggered === false && vehicleType == 'Car' || (liftedOptions.length < 1 && staggered === false)) {
                                    navigate(`/tires/tires-with-vehicle?year=${selectedYear}&make=${selectedMake}&model=${selectedModel}&variant=${selectedVariant}`);
                                }

                                if (liftedOptions.length > 0 && vehicleType == 'Truck') {
                                    navigate(`/tires/tires-with-vehicle-lifted?year=${selectedYear}&make=${selectedMake}&model=${selectedModel}&variant=${selectedVariant}`);

                                }



                            })
                            .catch((error) => {
                                console.log(error);
                            });



                    })
                    .catch((error) => {
                        console.log(error);
                    });




            } else {
                setTimeout(() => {
                    navigate(`/tires`);
                }, 1000);
            }





        }


        else if (id == 99) {

            if (selectedYear && selectedMake && selectedModel) {

                const apiKey = 'crQqKW9uFVL1bSu1uymaWx2UFTcvgdKE';

                let config = {
                    method: 'get',
                    maxBodyLength: Infinity,
                    url: `https://api.fitmentatlas.com/v1.1/services/Vehicles/smartsizes/?YearId=${selectedYear}&MakeId=${selectedMake}&ModelId=${selectedModel}&ProductType=wheel&SubmodelID=${selectedVariant}&DriveTypeId=${driveTypeId}`,
                    headers: {
                        'FG-ApiKey': apiKey
                    }
                };

                axios.request(config)

                    .then((response) => {

                        let staggered = false;
                        let fmkWithStaggered = null;

                        // CHECK STAGGERED
                        for (const obj of response.data.result) {

                            if (obj.isStaggered === true) {

                                fmkWithStaggered = obj.fmk;
                                staggered = true;
                                break;

                            }
                        }

                        // FALLBACK FIRST ITEM
                        if (
                            fmkWithStaggered === null &&
                            response.data.result.length > 0
                        ) {

                            fmkWithStaggered =
                                response.data.result[0].fmk;

                        }

                        // NO FMK
                        if (!fmkWithStaggered) {

                            navigate('/wheel-tire-packages');
                            return;

                        }

                        // SECOND API CALL
                        let config2 = {
                            method: 'get',
                            maxBodyLength: Infinity,
                            url: `https://api.fitmentatlas.com/v1.1/services/Vehicles/${fmkWithStaggered}`,
                            headers: {
                                'FG-ApiKey': apiKey
                            }
                        };

                        axios.request(config2)

                            .then((response2) => {

                                const vehicleData =
                                    response2.data.result;

                                const vehicleType =
                                    vehicleData.vehicleTypeName;

                                const liftedOptions =
                                    vehicleData?.vehicleChassis?.vehicleLiftedSizes || [];

                                // STAGGERED
                                if (staggered) {

                                    navigate(
                                        `/wheel-tire-packages/staggered?year=${selectedYear}&make=${selectedMake}&model=${selectedModel}&variant=${selectedVariant || ''}`
                                    );

                                    return;
                                }

                                // LIFTED TRUCK
                                if (
                                    vehicleType === 'Truck' &&
                                    liftedOptions.length > 0
                                ) {

                                    navigate(
                                        `/wheel-tire-packages/lifted?year=${selectedYear}&make=${selectedMake}&model=${selectedModel}&variant=${selectedVariant || ''}`
                                    );

                                    return;
                                }

                                // DEFAULT
                                navigate(
                                    `/wheel-tire-packages?year=${selectedYear}&make=${selectedMake}&model=${selectedModel}&variant=${selectedVariant || ''}`
                                );

                            })

                            .catch((error) => {

                                console.log(error);
                                navigate('/error');

                            });

                    })

                    .catch((error) => {

                        console.log(error);
                        navigate('/error');

                    });

            } else {

                navigate('/wheel-tire-packages');

            }
        }


        else {
            setTimeout(() => {
                navigate(`/products/${id}`);
            }, 1000);

        }

    }
    const fetchYearData = async () => {
        setIsLoading(true);
        try {
            let config = {
                method: 'get',
                maxBodyLength: Infinity,
                url: `${mainUrl}/api/getYear`,
            };
            axios
                .request(config)
                .then((response) => {
                    setDataYear(response.data);
                    setIsLoading(false);
                    if (selectedYear) {
                        fetchMakeData(selectedYear);
                    }

                })
                .catch((error) => {
                    console.log(error);
                    setIsLoading(false);
                });
        } catch (error) {
            console.error('Error fetching data:', error);
            setIsLoading(false);
        }
    };

    const handleYearChange = (event) => {

        setisOpenVarient(false);
        setisOpenModel(false);
        const selectedYear = event.value
        if (selectedYear === "") {
            setSelectedMake('');
            setSelectedModel('');
            setSelectedVariant('');
            setDataMake("")
            setDataModel("")
            setDataVarient("")

            setSelectedMakeName('')
            setSelectedModelName('')
            setSelectedVariantName('')

        } else {
            setSelectedYear(selectedYear);
            setSelectedMake('');
            setSelectedModel('');
            setSelectedVariant('');
            fetchMakeData(selectedYear);
            setIsLoaderMake(false);
            setShowMake(true)
            setSelectedMakeName('')
            setSelectedModelName('')
            setSelectedVariantName('')
            setisOpenMake(true);
            makeRef.current?.focus();

        }

    };

    const fetchMakeData = async (selectedYear) => {

        if (selectedYear) {
            setIsLoadingMake(true);
            try {
                let config = {
                    method: 'get',
                    maxBodyLength: Infinity,
                    url: `${mainUrl}/api/getMakeByYear/${selectedYear}`,
                };
                axios
                    .request(config)
                    .then((response) => {
                        setIsLoadingMake(false);
                        setDataMake(response.data);
                        setIsLoaderMake(true);

                        if (selectedYear && selectedMake) {
                            fetchModelData(selectedYear, selectedMake);
                        }

                    })
                    .catch((error) => {
                        console.log(error);
                        setIsLoadingMake(false);
                    });
            } catch (error) {
                console.error('Error fetching data:', error);
                setIsLoadingMake(false);
            }
        }
    };

    const handleMakeChange = (event) => {
        setisOpenVarient(false);
        const selectedMake = event.value;
        const selectedMakeName = event.label;
        setSelectedMake(selectedMake);
        setSelectedMakeName(selectedMakeName);
        setisOpenMake(false)

        setDataModel([]);
        setSelectedModel('');
        setSelectedVariant('');

        setIsLoaderModel(false)
        fetchModelData(selectedYear, selectedMake);
        setShowModel(true)
        setisOpenModel(true)
        setSelectedModelName('')
        setSelectedVariantName('')
        modelRef.current?.focus();

    };

    const fetchModelData = async (selectedYear, selectedMake) => {
        if (selectedYear && selectedMake) {
            setIsLoadingModel(true);
            try {
                let config = {
                    method: 'get',
                    maxBodyLength: Infinity,
                    url: `${mainUrl}/api/getModelByMake/${selectedYear}/${selectedMake}`,
                };
                axios
                    .request(config)
                    .then((response) => {

                        setIsLoadingModel(false);
                        setDataModel(response.data);
                        setIsLoaderModel(true)
                        if (selectedYear && selectedModel) {
                            fetchVariantData(selectedYear, selectedModel);
                        }

                    })
                    .catch((error) => {
                        console.log(error);
                        setIsLoadingModel(false);
                    });
            } catch (error) {
                console.error('Error fetching data:', error);
                setIsLoadingModel(false);
            }
        }
    };

    const handleModelChange = (event) => {
        setisOpenModel(false);
        setisOpenVarient(false);

        const selectedModel = event.value;
        const selectedModelName = event.label;
        setSelectedModel(selectedModel);
        setSelectedModelName(selectedModelName);
        setSelectedVariant('');
        setSelectedVariantName('')
        // Fetch variant data based on selected year, make, and model
        fetchVariantData(selectedYear, selectedModel);
        setIsLoaderVarient(false)
        setShowVarient(true)
        setisOpenVarient(true)
        variantRef.current?.focus();
    };
    const fetchVariantData = async (selectedYear, selectedModel) => {
        if (selectedYear && selectedModel) {
            setIsLoadingVarient(true);
            try {
                let config = {
                    method: 'get',
                    maxBodyLength: Infinity,
                    url: `${mainUrl}/api/getSubModelByModel/${selectedYear}/${selectedModel}`,
                };
                axios
                    .request(config)
                    .then((response) => {

                        setIsLoadingVarient(false);
                        setDataVarient(response.data);
                        setIsLoaderVarient(true)
                    })
                    .catch((error) => {
                        console.log(error);
                        setIsLoadingVarient(false);
                    });
            } catch (error) {
                console.error('Error fetching data:', error);
                setIsLoadingVarient(false);
            }
        }
    };

    const handleVarientChange = (event) => {
        setisOpenVarient(false)
        const selectedVarient = event.value;
        const selectedVarientName = event.label
        setSelectedVariant(selectedVarient);
        setSelectedVariantName(selectedVarientName);

    };

    const isOptionSelected = (option) => {
        if (!selectedVariant) {
            return false;
        }

        return (
            selectedVariant === option.value &&
            selectedVariantName.toLowerCase() === option.label.toLowerCase()
        );
    };



    const handleShow = () => {

        document.body.classList.remove('overflow_vehicle');
        let state = {
            year: selectedYear,
            make: selectedMake,
            model: selectedModel,
            variant: selectedVariant,
            make_name: selectedMakeName,
            model_name: selectedModelName,
            variant_name: selectedVariantName,
            // searchType: searchType,
        }
        // Save state in local storage
        localStorage.setItem('vehical_details', JSON.stringify(state));
        localStorage.removeItem('wheels_details');
        // Retrieve state from local storage  
        setTimeout(() => {
            navigate(`/categories-home/all-category`);
            window.location.reload();
        }, 1500); // Delay of 2000 milliseconds (2 seconds)s



    };
    const [showMenuSide, setShowMenuSide] = useState("")

    const setValueMenuSideBar = (value) => {
        setShowMenuSide(value)
    }

    // Category page URL used by onSubmit: 19 = Wheels, 35 = Tires, 99 = Wheel & Tire Packages
    const categoryPageUrl = (categoryId) => {
        if (categoryId == 19) return `${window.location.origin}/wheels`;
        if (categoryId == 35) return `${window.location.origin}/tires`;
        if (categoryId == 99) return `${window.location.origin}/wheel-tire-packages`;
        return `${window.location.origin}/products/${categoryId}`;
    };

    // ItemList = categories currently shown on the page, in display order
    const allCategoryPageUrl = window.location.origin + window.location.pathname;
    const categoryItems = loader && categoryData && categoryData.data
        ? categoryData.data.flatMap((section) => section[Object.keys(section)[0]] || [])
            .map((item) => ({ url: categoryPageUrl(item.category_id), name: item.category_name }))
        : [];
    const collectionSchema = buildCollectionPageSchema({
        name: "Categories",
        url: allCategoryPageUrl,
        description: "Browse all wheel, tire and accessory categories at Extreme Performance.",
        breadcrumb: collectionBreadcrumb("Categories", allCategoryPageUrl),
        items: categoryItems,
    });

    return (
        <>
            <Helmet>
                {collectionSchema && <script type="application/ld+json">{JSON.stringify(collectionSchema)}</script>}
            </Helmet>
            <TOPBAR isHidden={isHidden} />
            <SEARCHBAR setValueMenuSideBar={setValueMenuSideBar} cartItemsdata={cartItems} />
            <MENUBAR showMenuSide={showMenuSide} setValueMenuSideBar={setValueMenuSideBar} />
            <section>
                <div className="main-inner-banner">
                    <div className="parformane-bar">
                        <div className="container d-flex justify-content-between">

                            <ul className="p-0 m-0 listing-parmofamne">
                                <li>
                                    <a href="/">Home /</a>
                                </li>

                                <li className="active-bread">
                                    <a href="#" className='text-decoration-none text-light'>Categories</a>
                                </li>
                            </ul>

                        </div>
                    </div>
                    {/* <div className="five_percent_products"><img src='../icons/homepage_discount.png' /></div> */}
                    <h2 className="text-center txt-main-listing">Categories</h2>
                </div>

            </section>
            <section>
                <div className='container mt-3'>
                    {vehicalDetails ? <p>
                        <strong style={{ borderBottom: '2px solid black', fontSize: '30px' }}>
                            {vehicalDetails ? vehicalDetails.year : ""}&nbsp;
                            {vehicalDetails ? vehicalDetails.make_name : ""}&nbsp;
                            {vehicalDetails ? vehicalDetails.model_name : ""}&nbsp;
                            {vehicalDetails ? vehicalDetails.variant_name : ""}&nbsp;
                        </strong>    <i className="fa fa-pencil" title="Edit Search" style={{ cursor: 'pointer' }} onClick={onClickEdit}></i>
                    </p> : ""}
                </div>
                {
                    loader && categoryData ?
                        categoryData.data.length > 0 ?
                            categoryData.data.map((section, index) => {
                                const sectionId = Object.keys(section)[0];
                                const sectionData = section[sectionId];
                                const rootCategory = rootCategories.find(category => category.id == sectionId);
                                return (
                                    <section id={`section-${sectionId}`} key={sectionId} className='mt-10 all_category '>
                                        <div className='mt-5 category-main-section'>
                                            <div className='container mt-5'>
                                                <div className='row mt-4'>
                                                    <h3 className=''>{rootCategory ? rootCategory.name : '  '}</h3>
                                                    {sectionData.map((item, itemIndex) => (
                                                        <div className="col-lg-3 col-md-4 col-sm-4 col-4" key={itemIndex} onClick={() => onSubmit(item.category_id)}>
                                                            <div className="card">
                                                                <div className="row g-0 p-2">
                                                                    <div className="col-md-4">
                                                                        <img src={`/category/${item.image}`} alt="img" className="img-fluid" height="100%" width="100%" />
                                                                    </div>
                                                                    <div className="col-md-8 position-relative">
                                                                        <div className="card-body">
                                                                            <h4 className="card-title">{item.category_name} ({parseInt(item.count).toLocaleString('en-US')})</h4>
                                                                            {/* <span className='text-danger cursor_pointer'><u>View Products</u></span> */}
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    ))}
                                                </div>
                                            </div>
                                        </div>
                                    </section>
                                );
                            })
                            : <>
                                <div className='container text-center mt-5'>
                                    <h2>No Product Found</h2>
                                    <p>Sorry, we couldn't find any products matching your search criteria.</p>
                                    <p><a href='/' className=' btn btn-sm btn-danger'>Click here</a></p>
                                </div>

                            </>


                        :
                        <section className='mt-10'>
                            <div className='mt-5'>
                                <div className='container mt-5'>
                                    <div className='row'>
                                        <h2 className=''><ShimmerButton size="sm" /></h2>
                                        <div className="col-lg-3 col-md-4 col-sm-4 col-4">
                                            <div className="card">
                                                <div className="row g-0 p-3">
                                                    <div className="col-md-4">
                                                        <ShimmerThumbnail height={80} rounded />
                                                    </div>
                                                    <div className="col-md-8">
                                                        <div className="card-body">
                                                            <h4 className="card-title"><ShimmerButton size="sm" /></h4>
                                                            <span className='text-danger cursor_pointer'><u><ShimmerButton size="sm" /></u></span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-lg-3 col-md-4 col-sm-4 col-4">
                                            <div className="card">
                                                <div className="row g-0 p-3">
                                                    <div className="col-md-4">
                                                        <ShimmerThumbnail height={80} rounded />
                                                    </div>
                                                    <div className="col-md-8">
                                                        <div className="card-body">
                                                            <h4 className="card-title"><ShimmerButton size="sm" /></h4>
                                                            <span className='text-danger cursor_pointer'><u><ShimmerButton size="sm" /></u></span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-lg-3 col-md-4 col-sm-4 col-4">
                                            <div className="card">
                                                <div className="row g-0 p-3">
                                                    <div className="col-md-4">
                                                        <ShimmerThumbnail height={80} rounded />
                                                    </div>
                                                    <div className="col-md-8">
                                                        <div className="card-body">
                                                            <h4 className="card-title"><ShimmerButton size="sm" /></h4>
                                                            <span className='text-danger cursor_pointer'><u><ShimmerButton size="sm" /></u></span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-lg-3 col-md-4 col-sm-4 col-4">
                                            <div className="card">
                                                <div className="row g-0 p-3">
                                                    <div className="col-md-4">
                                                        <ShimmerThumbnail height={80} rounded />
                                                    </div>
                                                    <div className="col-md-8">
                                                        <div className="card-body">
                                                            <h4 className="card-title"><ShimmerButton size="sm" /></h4>
                                                            <span className='text-danger cursor_pointer'><u><ShimmerButton size="sm" /></u></span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-lg-3 col-md-4 col-sm-4 col-4">
                                            <div className="card">
                                                <div className="row g-0 p-3">
                                                    <div className="col-md-4">
                                                        <ShimmerThumbnail height={80} rounded />
                                                    </div>
                                                    <div className="col-md-8">
                                                        <div className="card-body">
                                                            <h4 className="card-title"><ShimmerButton size="sm" /></h4>
                                                            <span className='text-danger cursor_pointer'><u><ShimmerButton size="sm" /></u></span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-lg-3 col-md-4 col-sm-4 col-4">
                                            <div className="card">
                                                <div className="row g-0 p-3">
                                                    <div className="col-md-4">
                                                        <ShimmerThumbnail height={80} rounded />
                                                    </div>
                                                    <div className="col-md-8">
                                                        <div className="card-body">
                                                            <h4 className="card-title"><ShimmerButton size="sm" /></h4>
                                                            <span className='text-danger cursor_pointer'><u><ShimmerButton size="sm" /></u></span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-lg-3 col-md-4 col-sm-4 col-4">
                                            <div className="card">
                                                <div className="row g-0 p-3">
                                                    <div className="col-md-4">
                                                        <ShimmerThumbnail height={80} rounded />
                                                    </div>
                                                    <div className="col-md-8">
                                                        <div className="card-body">
                                                            <h4 className="card-title"><ShimmerButton size="sm" /></h4>
                                                            <span className='text-danger cursor_pointer'><u><ShimmerButton size="sm" /></u></span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-lg-3 col-md-4 col-sm-4 col-4">
                                            <div className="card">
                                                <div className="row g-0 p-3">
                                                    <div className="col-md-4">
                                                        <ShimmerThumbnail height={80} rounded />
                                                    </div>
                                                    <div className="col-md-8">
                                                        <div className="card-body">
                                                            <h4 className="card-title"><ShimmerButton size="sm" /></h4>
                                                            <span className='text-danger cursor_pointer'><u><ShimmerButton size="sm" /></u></span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </section>



                }

                <Modal show={showModal} onHide={handleClose} size="">
                    <Modal.Header closeButton>
                        <Modal.Title>Select Your Vehicle</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <div className="mian-inner-data-tab position-relative">
                            <div className='selectMainDivEditPopup'>
                                Year
                                {
                                    <Select
                                        options={dataYear.data}
                                        onChange={handleYearChange}
                                        placeholder='Year'
                                        value={{ value: selectedYear, label: selectedYear }}
                                        isSearchable={false}
                                    />
                                }
                                {
                                    !isLoading ? "" : <div className="loader"></div>
                                }

                            </div>

                            <div className='selectMainDivEditPopup'>
                                Make
                                {
                                    <Select
                                        menuIsOpen={isOpenMake}
                                        options={dataMake.data}
                                        onChange={handleMakeChange}
                                        openMenuOnClick={true}
                                        placeholder='Make'
                                        // value={{value: vehicalDetails.make, label: vehicalDetails.make_name}}
                                        value={{ value: selectedMake, label: selectedMakeName }}
                                        onMenuOpen={() => setisOpenMake(true)}
                                        onMenuClose={() => setisOpenMake(false)}
                                        isSearchable={false}
                                        ref={makeRef}


                                    />
                                }

                                {isLoaderMake ? "" : <div className="loaderMake"></div>}

                            </div>


                            <div className='selectMainDivEditPopup'>
                                Model
                                {
                                    <Select
                                        menuIsOpen={isOpenModel}
                                        options={dataModel.data}
                                        onChange={handleModelChange}
                                        openMenuOnClick={true}
                                        placeholder='Model'
                                        // value={{value: vehicalDetails.model, label: vehicalDetails.model_name}}
                                        value={{ value: selectedModel, label: selectedModelName }}
                                        onMenuOpen={() => setisOpenModel(true)}
                                        onMenuClose={() => setisOpenModel(false)}
                                        isSearchable={false}
                                        ref={modelRef}
                                    />
                                }
                                {isLoaderModel ? "" : <div className="loaderModel"></div>}


                            </div>


                            <div className='selectMainDivEditPopup'>
                                Sub Model
                                {
                                    <Select
                                        menuIsOpen={isOpenVarient}
                                        options={dataModelVarient.data}

                                        onChange={handleVarientChange}
                                        openMenuOnClick={true}
                                        placeholder='Varient'
                                        // value={{value: vehicalDetails.variant, label: vehicalDetails.variant_name}}
                                        value={{ value: selectedVariant, label: selectedVariantName }}
                                        onMenuOpen={() => setisOpenVarient(true)}
                                        onMenuClose={() => setisOpenVarient(false)}
                                        isOptionSelected={isOptionSelected}
                                        isSearchable={false}
                                        ref={variantRef}
                                    />
                                }
                                {isLoaderVarient ? "" : <div className="loaderVarient"></div>}

                            </div>

                            {/* <div className='selectMainDivEditPopup'>
                                Options
                                <select className='form-control' onChange={handleCheckRedirectionPage} value={searchType}>
                                    <option value="">Select Option</option>
                                    <option value="1">Wheels</option>
                                    <option value="2">Wheels and Accessories</option>
                                </select>
                            </div> */}

                            {
                                !selectedModel ?
                                    <div className="text-right" style={{ textAlign: 'right' }}>
                                        <button className="btn btn-sm btn-danger m-2" disabled>

                                            <svg width="32" height="23" viewBox="0 0 32 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path
                                                    d="M3.92351 7.13048C3.52844 7.13048 3.20801 7.45067 3.20801 7.84598C3.20801 8.24128 3.52845 8.56148 3.92351 8.56148H7.10778C7.21609 8.07632 7.35485 7.59841 7.52281 7.13048H3.92351Z"
                                                    fill="white"></path>
                                                <path
                                                    d="M5.3548 11.4239C5.3548 11.2342 5.27943 11.052 5.14516 10.918C5.01089 10.7837 4.82896 10.7084 4.63903 10.7084H1.06121C0.666136 10.7084 0.345703 11.0286 0.345703 11.4239C0.345703 11.8192 0.666149 12.1394 1.06121 12.1394H4.63903C4.82896 12.1394 5.01089 12.064 5.14516 11.9297C5.27943 11.7957 5.3548 11.6136 5.3548 11.4239Z"
                                                    fill="white"></path>
                                                <path
                                                    d="M3.92351 14.2861C3.52844 14.2861 3.20801 14.6063 3.20801 15.0017C3.20801 15.397 3.52845 15.7172 3.92351 15.7172H7.53724C7.36904 15.2492 7.23052 14.7713 7.12221 14.2861H3.92351Z"
                                                    fill="white"></path>
                                                <path d="M12.9824 13.9284C13.2689 14.7036 13.6904 15.4218 14.2275 16.05L15.4117 13.9284H12.9824Z"
                                                    fill="white"></path>
                                                <path
                                                    d="M22.7293 10.3505C22.4725 10.3528 22.2342 10.2175 22.1049 9.99566C21.9754 9.77379 21.9749 9.49977 22.1031 9.27716L24.0672 5.76718L24.0675 5.76743C23.4975 5.32769 22.8658 4.9743 22.1927 4.71899L20.3072 8.0964V8.09665C20.1782 8.32002 19.9388 8.45653 19.681 8.45429C19.423 8.45653 19.1839 8.32002 19.0549 8.09665L17.1621 4.72621C16.489 4.98152 15.8574 5.33491 15.2873 5.77438L17.2552 9.27708C17.3837 9.4997 17.383 9.77372 17.2537 9.99558C17.1242 10.2175 16.8858 10.3527 16.629 10.3505H12.6078C12.4979 11.062 12.4979 11.7858 12.6078 12.4973H16.629C16.8858 12.4951 17.1242 12.6303 17.2537 12.8522C17.383 13.0741 17.3837 13.3481 17.2552 13.5707L15.2911 17.0807V17.0804C15.8604 17.5174 16.4908 17.8681 17.1621 18.1216L19.0511 14.7442H19.0513C19.1804 14.5209 19.4194 14.3841 19.6775 14.3863C19.9353 14.3841 20.1746 14.5209 20.3034 14.7442L22.1889 18.1216C22.862 17.8663 23.494 17.5129 24.064 17.0735L22.1031 13.5708C21.9749 13.3481 21.9754 13.0741 22.1049 12.8523C22.2342 12.6304 22.4725 12.4951 22.7293 12.4974H26.7509C26.8654 11.7863 26.8654 11.0616 26.7509 10.3505L22.7293 10.3505ZM19.6668 12.1395C19.3773 12.1395 19.1163 11.9653 19.0057 11.6977C18.8949 11.4304 18.956 11.1227 19.1607 10.9181C19.3653 10.7134 19.673 10.652 19.9406 10.7628C20.2079 10.8737 20.3823 11.1345 20.3823 11.424C20.3823 11.6136 20.3069 11.7958 20.1727 11.9299C20.0384 12.0641 19.8565 12.1395 19.6668 12.1395Z"
                                                    fill="white"></path>
                                                <path
                                                    d="M18.5928 18.4939C19.3101 18.6047 20.04 18.6047 20.7573 18.4939L19.6839 16.5583L18.5928 18.4939Z"
                                                    fill="white"></path>
                                                <path d="M14.2275 6.79761C13.6904 7.42577 13.2689 8.14402 12.9824 8.9192H15.4117L14.2275 6.79761Z"
                                                    fill="white"></path>
                                                <path
                                                    d="M20.7602 4.35383C20.0429 4.24302 19.313 4.24302 18.5957 4.35383L19.6691 6.2895L20.7602 4.35383Z"
                                                    fill="white"></path>
                                                <path d="M26.374 8.91941C26.0873 8.14423 25.6657 7.42599 25.1289 6.79782L23.959 8.91941H26.374Z"
                                                    fill="white"></path>
                                                <path d="M25.129 16.0502C25.6658 15.422 26.0873 14.7037 26.3741 13.9286H23.959L25.129 16.0502Z"
                                                    fill="white"></path>
                                                <path
                                                    d="M29.6843 11.4239C29.6843 11.0286 30.0047 10.7084 30.4001 10.7084H31.1156C30.9538 8.16876 29.9463 5.75667 28.2532 3.85684L27.7773 4.34001C27.4978 4.62052 27.0436 4.62127 26.7631 4.34175C26.4825 4.06224 26.4818 3.60804 26.7613 3.3275L27.248 2.83735C25.3405 1.15078 22.9234 0.151994 20.3824 0V0.690585C20.3824 1.0859 20.0619 1.40609 19.6669 1.40609C19.2715 1.40609 18.9511 1.08589 18.9511 0.690585V0C16.4105 0.161718 13.9972 1.16925 12.0964 2.86233L12.583 3.34524H12.5828C12.7535 3.46828 12.8616 3.65995 12.878 3.86959C12.8947 4.07922 12.8181 4.28562 12.6689 4.43386C12.5196 4.58211 12.3128 4.65698 12.1034 4.63901C11.8937 4.62079 11.7028 4.51148 11.581 4.34002L11.1016 3.8571V3.85685C9.40876 5.75681 8.40096 8.16891 8.23926 10.7084H8.93355C9.32862 10.7084 9.64905 11.0286 9.64905 11.4239C9.64905 11.8192 9.32861 12.1394 8.93355 12.1394H8.25721C8.41868 14.679 9.42646 17.0911 11.1195 18.9909L11.581 18.5078C11.8608 18.2273 12.3147 18.2265 12.5952 18.506C12.876 18.7856 12.8768 19.2397 12.5972 19.5203L12.1106 20.0104C14.0118 21.7035 16.4251 22.7113 18.966 22.8728V22.1573C18.966 21.7619 19.2862 21.4418 19.6815 21.4418C20.0765 21.4418 20.397 21.762 20.397 22.1573V22.8479C22.9363 22.6856 25.3484 21.6781 27.2485 19.9855L26.7618 19.5026C26.4823 19.2218 26.4831 18.7679 26.7636 18.4881C27.0441 18.2086 27.4983 18.2093 27.7778 18.4901L28.2538 18.991C29.9469 17.091 30.9544 14.6789 31.1161 12.1394H30.4006C30.0053 12.1394 29.6848 11.8192 29.6848 11.4239L29.6843 11.4239ZM28.0314 13.3523C27.6426 15.0479 26.7421 16.5827 25.4519 17.7495C24.4813 18.6265 23.3237 19.2713 22.0672 19.635C20.5241 20.0785 18.8874 20.0785 17.3446 19.635H17.3194C16.071 19.2706 14.9212 18.6285 13.9561 17.7568C13.3155 17.174 12.7654 16.4987 12.3247 15.7533C11.8895 15.0078 11.5698 14.2007 11.3766 13.3596C11.0856 12.0903 11.0856 10.7718 11.3766 9.50278C11.7654 7.80721 12.6661 6.27239 13.9561 5.10563C14.9067 4.2274 16.0428 3.57426 17.2799 3.19494H17.3051C18.8561 2.74871 20.5015 2.74871 22.0529 3.19494H22.0778C23.3262 3.55956 24.4759 4.20172 25.441 5.07343C26.0819 5.65593 26.6317 6.33129 27.0725 7.07695C27.5077 7.82216 27.8274 8.62928 28.0206 9.47058C28.3163 10.7391 28.3163 12.0589 28.0206 13.3274L28.0314 13.3523Z"
                                                    fill="white"></path>
                                            </svg>
                                            Search
                                        </button>
                                    </div>
                                    :
                                    <div className="text-right" style={{ textAlign: 'right' }}>
                                        <button className="btn btn btn-danger srch_btn m-2 " onClick={() => handleShow()} >

                                            <svg width="32" height="23" viewBox="0 0 32 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path
                                                    d="M3.92351 7.13048C3.52844 7.13048 3.20801 7.45067 3.20801 7.84598C3.20801 8.24128 3.52845 8.56148 3.92351 8.56148H7.10778C7.21609 8.07632 7.35485 7.59841 7.52281 7.13048H3.92351Z"
                                                    fill="white"></path>
                                                <path
                                                    d="M5.3548 11.4239C5.3548 11.2342 5.27943 11.052 5.14516 10.918C5.01089 10.7837 4.82896 10.7084 4.63903 10.7084H1.06121C0.666136 10.7084 0.345703 11.0286 0.345703 11.4239C0.345703 11.8192 0.666149 12.1394 1.06121 12.1394H4.63903C4.82896 12.1394 5.01089 12.064 5.14516 11.9297C5.27943 11.7957 5.3548 11.6136 5.3548 11.4239Z"
                                                    fill="white"></path>
                                                <path
                                                    d="M3.92351 14.2861C3.52844 14.2861 3.20801 14.6063 3.20801 15.0017C3.20801 15.397 3.52845 15.7172 3.92351 15.7172H7.53724C7.36904 15.2492 7.23052 14.7713 7.12221 14.2861H3.92351Z"
                                                    fill="white"></path>
                                                <path d="M12.9824 13.9284C13.2689 14.7036 13.6904 15.4218 14.2275 16.05L15.4117 13.9284H12.9824Z"
                                                    fill="white"></path>
                                                <path
                                                    d="M22.7293 10.3505C22.4725 10.3528 22.2342 10.2175 22.1049 9.99566C21.9754 9.77379 21.9749 9.49977 22.1031 9.27716L24.0672 5.76718L24.0675 5.76743C23.4975 5.32769 22.8658 4.9743 22.1927 4.71899L20.3072 8.0964V8.09665C20.1782 8.32002 19.9388 8.45653 19.681 8.45429C19.423 8.45653 19.1839 8.32002 19.0549 8.09665L17.1621 4.72621C16.489 4.98152 15.8574 5.33491 15.2873 5.77438L17.2552 9.27708C17.3837 9.4997 17.383 9.77372 17.2537 9.99558C17.1242 10.2175 16.8858 10.3527 16.629 10.3505H12.6078C12.4979 11.062 12.4979 11.7858 12.6078 12.4973H16.629C16.8858 12.4951 17.1242 12.6303 17.2537 12.8522C17.383 13.0741 17.3837 13.3481 17.2552 13.5707L15.2911 17.0807V17.0804C15.8604 17.5174 16.4908 17.8681 17.1621 18.1216L19.0511 14.7442H19.0513C19.1804 14.5209 19.4194 14.3841 19.6775 14.3863C19.9353 14.3841 20.1746 14.5209 20.3034 14.7442L22.1889 18.1216C22.862 17.8663 23.494 17.5129 24.064 17.0735L22.1031 13.5708C21.9749 13.3481 21.9754 13.0741 22.1049 12.8523C22.2342 12.6304 22.4725 12.4951 22.7293 12.4974H26.7509C26.8654 11.7863 26.8654 11.0616 26.7509 10.3505L22.7293 10.3505ZM19.6668 12.1395C19.3773 12.1395 19.1163 11.9653 19.0057 11.6977C18.8949 11.4304 18.956 11.1227 19.1607 10.9181C19.3653 10.7134 19.673 10.652 19.9406 10.7628C20.2079 10.8737 20.3823 11.1345 20.3823 11.424C20.3823 11.6136 20.3069 11.7958 20.1727 11.9299C20.0384 12.0641 19.8565 12.1395 19.6668 12.1395Z"
                                                    fill="white"></path>
                                                <path
                                                    d="M18.5928 18.4939C19.3101 18.6047 20.04 18.6047 20.7573 18.4939L19.6839 16.5583L18.5928 18.4939Z"
                                                    fill="white"></path>
                                                <path d="M14.2275 6.79761C13.6904 7.42577 13.2689 8.14402 12.9824 8.9192H15.4117L14.2275 6.79761Z"
                                                    fill="white"></path>
                                                <path
                                                    d="M20.7602 4.35383C20.0429 4.24302 19.313 4.24302 18.5957 4.35383L19.6691 6.2895L20.7602 4.35383Z"
                                                    fill="white"></path>
                                                <path d="M26.374 8.91941C26.0873 8.14423 25.6657 7.42599 25.1289 6.79782L23.959 8.91941H26.374Z"
                                                    fill="white"></path>
                                                <path d="M25.129 16.0502C25.6658 15.422 26.0873 14.7037 26.3741 13.9286H23.959L25.129 16.0502Z"
                                                    fill="white"></path>
                                                <path
                                                    d="M29.6843 11.4239C29.6843 11.0286 30.0047 10.7084 30.4001 10.7084H31.1156C30.9538 8.16876 29.9463 5.75667 28.2532 3.85684L27.7773 4.34001C27.4978 4.62052 27.0436 4.62127 26.7631 4.34175C26.4825 4.06224 26.4818 3.60804 26.7613 3.3275L27.248 2.83735C25.3405 1.15078 22.9234 0.151994 20.3824 0V0.690585C20.3824 1.0859 20.0619 1.40609 19.6669 1.40609C19.2715 1.40609 18.9511 1.08589 18.9511 0.690585V0C16.4105 0.161718 13.9972 1.16925 12.0964 2.86233L12.583 3.34524H12.5828C12.7535 3.46828 12.8616 3.65995 12.878 3.86959C12.8947 4.07922 12.8181 4.28562 12.6689 4.43386C12.5196 4.58211 12.3128 4.65698 12.1034 4.63901C11.8937 4.62079 11.7028 4.51148 11.581 4.34002L11.1016 3.8571V3.85685C9.40876 5.75681 8.40096 8.16891 8.23926 10.7084H8.93355C9.32862 10.7084 9.64905 11.0286 9.64905 11.4239C9.64905 11.8192 9.32861 12.1394 8.93355 12.1394H8.25721C8.41868 14.679 9.42646 17.0911 11.1195 18.9909L11.581 18.5078C11.8608 18.2273 12.3147 18.2265 12.5952 18.506C12.876 18.7856 12.8768 19.2397 12.5972 19.5203L12.1106 20.0104C14.0118 21.7035 16.4251 22.7113 18.966 22.8728V22.1573C18.966 21.7619 19.2862 21.4418 19.6815 21.4418C20.0765 21.4418 20.397 21.762 20.397 22.1573V22.8479C22.9363 22.6856 25.3484 21.6781 27.2485 19.9855L26.7618 19.5026C26.4823 19.2218 26.4831 18.7679 26.7636 18.4881C27.0441 18.2086 27.4983 18.2093 27.7778 18.4901L28.2538 18.991C29.9469 17.091 30.9544 14.6789 31.1161 12.1394H30.4006C30.0053 12.1394 29.6848 11.8192 29.6848 11.4239L29.6843 11.4239ZM28.0314 13.3523C27.6426 15.0479 26.7421 16.5827 25.4519 17.7495C24.4813 18.6265 23.3237 19.2713 22.0672 19.635C20.5241 20.0785 18.8874 20.0785 17.3446 19.635H17.3194C16.071 19.2706 14.9212 18.6285 13.9561 17.7568C13.3155 17.174 12.7654 16.4987 12.3247 15.7533C11.8895 15.0078 11.5698 14.2007 11.3766 13.3596C11.0856 12.0903 11.0856 10.7718 11.3766 9.50278C11.7654 7.80721 12.6661 6.27239 13.9561 5.10563C14.9067 4.2274 16.0428 3.57426 17.2799 3.19494H17.3051C18.8561 2.74871 20.5015 2.74871 22.0529 3.19494H22.0778C23.3262 3.55956 24.4759 4.20172 25.441 5.07343C26.0819 5.65593 26.6317 6.33129 27.0725 7.07695C27.5077 7.82216 27.8274 8.62928 28.0206 9.47058C28.3163 10.7391 28.3163 12.0589 28.0206 13.3274L28.0314 13.3523Z"
                                                    fill="white"></path>
                                            </svg>
                                            <img className="wheel_gif_icon" src="/images/wheel_ic_gif.gif" alt="img" width="100%" height="100%" />
                                            Search
                                        </button>
                                        <button className="btn btn btn-danger restButton"  >
                                            <i className="fa fa-refresh" aria-hidden="true"></i>
                                            Reset
                                        </button>
                                    </div>

                            }
                        </div>


                    </Modal.Body>
                </Modal>
            </section>
            {/* <NEWSLETTER /> */}
            < FOOTER />
        </>

    )
}
